import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-joining-kit',
  templateUrl: './employee-joining-kit.component.html',
  styleUrls: ['./employee-joining-kit.component.scss']
})
export class EmployeeJoiningKitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
